import script from "./ProjectResourceAllocationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectResourceAllocationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectResourceAllocationsPage.vue?vue&type=style&index=0&id=33e042a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e042a8"]])

export default __exports__